export const popoverTheme = {
  root: {
    borderRadius: '{content.border.radius}',
    shadow: '{shadow.level3}',
    gutter: '10px',
    arrowOffset: '1.25rem'
  },
  content: {
    padding: '0'
  },
  colorScheme: {
    light: {
      root: {
        background: '{content.background}',
        borderColor: '{content.border.color}'
      }
    },
    dark: {
      root: {
        background: '{content.background}',
        borderColor: '{content.border.color}'
      }
    }
  }
};
